export const initialState = {
  name: 'app',
  state: 'loading',
  services: {},
  theme: 'light',
  config: {
    auth: {
      allowPasswordChange: {
        ui: false,
        email: false,
      },
    },
    similarityThresholds: {
      low: 0.75,
      medium: 0.95,
    },
    maxImageSize: null,
    license: {},
  },
  features: {
    license: false,
    estimations: {
      face_quality: false,
      body_attributes: false,
      liveness: false,
      deepfake: false,
      people_counter: false,
    },
    components: {
      events: false,
      tasks: false,
      sender: false,
      handlers: false,
      image_store: false,
      lambdas: false,
      video_analytics: false,
    },
  },
  plugins: [],
};
